import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosize"
export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    const textarea = this.element
    
    // Reset height to get the correct scrollHeight
    textarea.style.height = 'auto'
    
    // Set the height to match the content
    const minHeight = 80 // Minimum height in pixels
    const maxHeight = 200 // Maximum height before scrolling
    const scrollHeight = textarea.scrollHeight
    
    if (scrollHeight < minHeight) {
      textarea.style.height = minHeight + 'px'
    } else if (scrollHeight > maxHeight) {
      textarea.style.height = maxHeight + 'px'
      textarea.style.overflowY = 'auto'
    } else {
      textarea.style.height = scrollHeight + 'px'
      textarea.style.overflowY = 'hidden'
    }
  }

  input() {
    this.resize()
  }
}
